import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetCollectionsForProjectQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  order?: Types.CollectionsOrderInput;
  page?: Types.PageInput;
}>;


export type GetCollectionsForProjectQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, project?: { __typename?: 'Project', id: string, collections?: { __typename?: 'CollectionConnection', totalCount: number, nodes: Array<{ __typename?: 'Collection', id: string, insertedAt: string, private?: boolean | null, name: string, creator?: { __typename?: 'AuthenticatedUser', id: string, name?: string | null } | null, appearance: { __typename?: 'AssetAggregateAppearance', header?: { __typename?: 'AssetAggregateAppearanceHeader', iconEmoji?: string | null, newIconEmoji?: string | null, isIconEnabled?: boolean | null, iconImages?: { __typename?: 'Images', image128?: string | null } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null } | null };

export type ProjectCollectionFragment = { __typename?: 'Collection', id: string, insertedAt: string, private?: boolean | null, name: string, creator?: { __typename?: 'AuthenticatedUser', id: string, name?: string | null } | null, appearance: { __typename?: 'AssetAggregateAppearance', header?: { __typename?: 'AssetAggregateAppearanceHeader', iconEmoji?: string | null, newIconEmoji?: string | null, isIconEnabled?: boolean | null, iconImages?: { __typename?: 'Images', image128?: string | null } | null } | null } };

export const ProjectCollection = /*#__PURE__*/ gql`
    fragment ProjectCollection on Collection {
  id
  insertedAt
  creator {
    id
    name
  }
  private
  name
  appearance {
    header {
      iconEmoji
      newIconEmoji
      isIconEnabled
      iconImages {
        image128
      }
    }
  }
}
    ` as unknown as DocumentNode<ProjectCollectionFragment, unknown>;
export const GetCollectionsForProject = /*#__PURE__*/ gql`
    query GetCollectionsForProject($projectId: ID!, $order: CollectionsOrderInput! = {field: INSERTED_AT, direction: DESC_NULLS_LAST}, $page: PageInput! = {first: 50}) {
  account(by: {projectId: $projectId}) {
    id
    project(id: $projectId) {
      id
      collections(page: $page, order: $order) {
        totalCount
        nodes {
          ...ProjectCollection
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
}
    ${ProjectCollection}` as unknown as DocumentNode<GetCollectionsForProjectQuery, GetCollectionsForProjectQueryVariables>;

        

        
export const useProjectCollectionFragment = (
  input: string | Omit<UseFragmentOptions<ProjectCollectionFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Collection' } };
    return input;
  })();

  return useFragment<ProjectCollectionFragment>({
    fragment: ProjectCollection,
    fragmentName: 'ProjectCollection',
    ...options,
  });
};
  
        
          

          export const useGetCollectionsForProjectQuery = (options?:QueryHookOptions<GetCollectionsForProjectQuery, GetCollectionsForProjectQueryVariables>) => useQuery(GetCollectionsForProject, options);

          

          export type GetCollectionsForProjectQueryOptions = QueryHookOptions<GetCollectionsForProjectQuery, GetCollectionsForProjectQueryVariables>;

          

          export const useGetCollectionsForProjectLazyQuery = (options?:LazyQueryHookOptions<GetCollectionsForProjectQuery, GetCollectionsForProjectQueryVariables>) => useLazyQuery(GetCollectionsForProject, options);

          

          export type GetCollectionsForProjectQueryResult = ReturnType<typeof useGetCollectionsForProjectQuery>;

          
